WiseMetering.Collection.Plans = WiseMetering.Collection.extend({
    hasOrganization: true,
    model: WiseMetering.Model.Plan,
    url: '/plans',

    comparator: function(model) {
        const sort = ['essentials', 'standard', 'advanced', 'premium'];
        return sort.indexOf(model.get('name'));
    },

    loadFromBootstrap: function() {
        try {
            const bootstrapData = $.ajax({
                url: `/bootstrap?organization_id=${WiseMetering.currentOrganization.id}`,
                async: false
            }).responseJSON;

            if (bootstrapData && bootstrapData.plans) {
                this.reset(bootstrapData.plans);
                return true;
            }
        } catch (e) {
            console.warn('Failed to load plans data from bootstrap:', e);
        }
        return false;
    }
});
